"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComparisonTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentHeader = require("../../base-components/ComponentHeader/ComponentHeader");
var _Image = require("../../base-components/Image/Image");
var _Typography = require("../../base-components/Typography/Typography");
var _ButtonWithIcon = require("../../base-components/Button/variants/ButtonWithIcon/ButtonWithIcon");
var _Button = require("../../base-components/Button/Button");
var _MatchHeight = require("../../utils/MatchHeight");
var _PropertyProvider = require("../../utils/PropertyProvider/PropertyProvider");
var _svgFetcher = _interopRequireDefault(require("../../utils/svgFetcher"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ComparisonTable = exports.ComparisonTable = /*#__PURE__*/function (_React$Component) {
  _inherits(ComparisonTable, _React$Component);
  var _super = _createSuper(ComparisonTable);
  function ComparisonTable(props) {
    var _this;
    _classCallCheck(this, ComparisonTable);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "toggleExpand", function () {
      var tableExpanded = _this.state.tableExpanded;
      var onExpandCollapse = _this.props.onExpandCollapse;
      var stateObj = {
        tableExpanded: !tableExpanded
      };
      _this.setState(stateObj);
      if (typeof onExpandCollapse === 'function') {
        onExpandCollapse(Object.assign({}, stateObj));
      }
    });
    _this.state = {
      tableExpanded: false
    };
    return _this;
  }
  _createClass(ComparisonTable, [{
    key: "buildRows",
    value: function buildRows(rows, card, columnQeId) {
      var tableExpanded = this.state.tableExpanded;
      var _this$props = this.props,
        visibleRows = _this$props.visibleRows,
        _onClick = _this$props.onClick,
        CardNameComponent = _this$props.CardNameComponent;
      var shownRows = rows.slice(0, visibleRows).map(function (row, rowIndex) {
        var key = "row-".concat(rowIndex);
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: key,
          "data-qe-id": columnQeId ? "".concat(columnQeId, "__shown-rows") : undefined
        }, row.imageUrl && /*#__PURE__*/_react["default"].createElement(_Image.Image, {
          src: row.imageUrl,
          alt: row.imageAlt,
          onClick: function onClick() {
            _onClick(card.cardUrl);
          },
          qeId: columnQeId ? "".concat(columnQeId, "__card-art") : undefined
        }), /*#__PURE__*/_react["default"].createElement(_MatchHeight.MatchHeight, {
          name: key
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "cardRow",
          onClick: rowIndex === 0 ? function () {
            return _onClick(card.cardUrl);
          } : undefined
        }, /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
          components: row.components,
          ChildComponent: rowIndex === 0 ? CardNameComponent : undefined
        }))));
      });
      var hiddenRowsClassName = (0, _classnames["default"])('hiddenRows', {
        show: tableExpanded
      });
      var hiddenRows = /*#__PURE__*/_react["default"].createElement("div", {
        className: hiddenRowsClassName,
        key: "hidden-row",
        "data-qe-id": columnQeId ? "".concat(columnQeId, "__hidden-rows") : undefined
      }, rows.slice(visibleRows, rows.length).map(function (row, rowIndex) {
        var key = "hidden-row-".concat(rowIndex);
        return /*#__PURE__*/_react["default"].createElement(_MatchHeight.MatchHeight, {
          name: key,
          key: key
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "cardRow"
        }, row.components && /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
          components: row.components
        })));
      }));
      return [shownRows, hiddenRows];
    }
  }, {
    key: "buildButton",
    value: function buildButton() {
      var _this$props2 = this.props,
        styles = _this$props2.styles,
        collapseButtonLabel = _this$props2.collapseButtonLabel,
        expandButtonLabel = _this$props2.expandButtonLabel,
        showMoreButtonProps = _this$props2.showMoreButtonProps,
        namespace = _this$props2.namespace,
        CheckSvg = _this$props2.CheckSvg,
        qeId = _this$props2.qeId;
      var tableExpanded = this.state.tableExpanded;
      var buttonText = tableExpanded ? collapseButtonLabel : expandButtonLabel;
      return /*#__PURE__*/_react["default"].createElement(_ButtonWithIcon.ButtonWithIcon, {
        dtm: showMoreButtonProps.dtm,
        className: "toggle-button",
        toggled: tableExpanded,
        content: buttonText,
        onClick: this.toggleExpand,
        Svg: CheckSvg,
        styles: styles.button,
        iconFirst: false,
        namespace: (0, _PropertyProvider.NS)(namespace, 'show-more'),
        qeId: qeId ? "".concat(qeId, "__toggle-button") : undefined
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        cards = _this$props3.cards,
        className = _this$props3.className,
        styles = _this$props3.styles,
        title = _this$props3.title,
        titleProps = _this$props3.titleProps,
        subTitle = _this$props3.subTitle,
        mobileText = _this$props3.mobileText,
        compareButtonProps = _this$props3.compareButtonProps,
        namespace = _this$props3.namespace,
        qeId = _this$props3.qeId;
      var classNames = (0, _classnames["default"])('comparison-table', className, styles.compareTable.comparisonTable);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classNames,
        "data-qe-id": qeId
      }, /*#__PURE__*/_react["default"].createElement(_ComponentHeader.ComponentHeader, _extends({
        title: title,
        subTitle: subTitle,
        styles: styles.title,
        qeId: qeId ? "".concat(qeId, "__title") : undefined
      }, titleProps)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "compare-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "compare-table"
      }, /*#__PURE__*/_react["default"].createElement(_MatchHeight.MatchHeightProvider, null, cards.map(function (card, columnIndex) {
        var key = "column-".concat(columnIndex);
        var columnQeId = qeId ? "".concat(qeId, "__row-").concat(columnIndex + 1) : undefined;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "cardColumn",
          key: key,
          "data-qe-id": columnQeId
        }, _this2.buildRows(card.rows, card, columnQeId));
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.compareTable.buttonContainer
      }, this.buildButton()), /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.compareTable.compareMobileText,
        "data-qe-id": qeId ? "".concat(qeId, "__mobile-text") : undefined
      }, mobileText), compareButtonProps && compareButtonProps.children && /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.compareTable.compareButtonContainer
      }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
        className: compareButtonProps.className,
        styles: compareButtonProps.styles,
        title: compareButtonProps.title,
        dtm: compareButtonProps.dtm,
        onClick: compareButtonProps.onClick,
        namespace: (0, _PropertyProvider.NS)(namespace, 'compare'),
        qeId: qeId ? "".concat(qeId, "__compare-button") : undefined
      }, compareButtonProps.children))));
    }
  }]);
  return ComparisonTable;
}(_react["default"].Component);
ComparisonTable.propTypes = {
  cards: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    rows: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      imageUrl: _propTypes["default"].string,
      imageAlt: _propTypes["default"].string,
      components: _propTypes["default"].objectOf(_propTypes["default"].string)
    }))
  })),
  CardNameComponent: _propTypes["default"].string,
  className: _propTypes["default"].string,
  collapseButtonLabel: _propTypes["default"].string,
  expandButtonLabel: _propTypes["default"].string,
  styles: _propTypes["default"].shape({
    compareTable: _propTypes["default"].shape({
      comparisonTable: _propTypes["default"].string
    }).isRequired,
    title: _propTypes["default"].object.isRequired,
    button: _propTypes["default"].object.isRequired
  }),
  title: _propTypes["default"].string.isRequired,
  titleProps: _propTypes["default"].shape({
    Component: _propTypes["default"].node
  }),
  subTitle: _propTypes["default"].string,
  visibleRows: _propTypes["default"].number,
  onClick: _propTypes["default"].func.isRequired,
  showMoreButtonProps: _propTypes["default"].shape({
    dtm: _propTypes["default"].object
  }),
  compareButtonProps: _propTypes["default"].shape({
    className: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    children: _propTypes["default"].node
  }),
  mobileText: _propTypes["default"].node,
  onExpandCollapse: _propTypes["default"].func,
  namespace: _propTypes["default"].string,
  CheckSvg: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  qeId: _propTypes["default"].string
};
ComparisonTable.defaultProps = {
  cards: [],
  CardNameComponent: 'div',
  className: undefined,
  collapseButtonLabel: 'Show Less',
  expandButtonLabel: 'Show More',
  onExpandCollapse: undefined,
  namespace: '',
  styles: {
    compareTable: {},
    title: {},
    button: {}
  },
  subTitle: undefined,
  titleProps: {
    Component: undefined
  },
  visibleRows: 3,
  showMoreButtonProps: {
    dtm: {}
  },
  compareButtonProps: {
    className: '',
    onClick: undefined,
    children: 'Compare all Cards'
  },
  mobileText: 'Swipe right to view more',
  CheckSvg: function CheckSvg() {
    return (0, _svgFetcher["default"])('axp-glyph-down', 'us-consumer');
  },
  qeId: undefined
};